import * as session from './session';
import type { Session } from './session';

/* AuthService seam — now backed by our backend GoTrue proxy (lib/session), NOT */
/* supabase-js. Shapes mirror what the callers used (`{ error }`, */
/* `{ data: { session } }`, `onAuthStateChange`) so SignIn/ResetPassword/useAuth/ */
/* Header stay unchanged. supabase-js is no longer imported anywhere in the web. */

/* Process recovery / magic-link tokens from the URL hash on first load. */
session.initFromUrl();

type AuthError = { message: string } | null;
const wrap = (error: string | null): { error: AuthError } => ({ error: error ? { message: error } : null });

export const authClient = {
  signIn: async (email: string, password: string) => wrap((await session.signIn(email, password)).error),
  signUp: async (email: string, password: string) => wrap((await session.signUp(email, password)).error),
  resetPasswordForEmail: async (email: string, options?: { redirectTo?: string }) =>
    wrap((await session.recover(email, options?.redirectTo)).error),
  updatePassword: async (password: string) => wrap((await session.updatePassword(password)).error),
  getSession: async (): Promise<{ data: { session: Session | null } }> => ({ data: { session: session.getSession() } }),
  onAuthStateChange: (cb: (event: session.AuthEvent, s: Session | null) => void) => {
    const unsubscribe = session.onSessionChange(cb);
    return { data: { subscription: { unsubscribe } } };
  },
  signOut: async () => session.signOut(),
};
